// export const Deff = (Autodesk) => {
//   logger.log("Deff extension loaded", Autodesk);
//   class ModelDiff extends Autodesk.Viewing.Extension {
//     constructor(viewer, options) {
//       super(viewer, options);
//       this._group = null;
//       this._button = null;
//     }
//     load() {
//       console.log("Model Difference has been loaded");
//       return true;
//     }

//     unload() {
//       console.log("Model Difference has been unloaded");
//       return true;
//     }

//     modelDiff() {
//       var extensionConfig = {};
//       extensionConfig.mimeType = "application/vnd.autodesk.revit";
//       extensionConfig.primaryModels = [NOP_VIEWER.impl.get3DModels()[0]];
//       extensionConfig.diffModels = [NOP_VIEWER.impl.get3DModels()[1]];
//       extensionConfig.diffMode = "overlay";
//       extensionConfig.versionA = "1";
//       extensionConfig.versionB = "2";
//       NOP_VIEWER.loadExtension("Autodesk.DiffTool", extensionConfig).catch(
//         function (err) {
//           console.log(err);
//         },
//       );
//     }

//     onToolbarCreated() {
//       // alert('TODO: customize Viewer toolbar');

//       this._group = this.viewer.toolbar.getControl("modelDifferenctTool");

//       if (!this._group) {
//         this._group = new Autodesk.Viewing.UI.ControlGroup(
//           "modelDifferenctTool",
//         );
//         this.viewer.toolbar.addControl(this._group);
//       }

//       this._button = new Autodesk.Viewing.UI.Button("diffToolButtonCombo");

//       this._button.onClick = (e) => {
//         this.modelDiff();
//       };

//       // this._group = new Autodesk.Viewing.UI.ControlGroup(
//       //   "diff-tool-group-show-diff"
//       // );
//       this._button.setToolTip("Model Comper");
//       this._button.addClass("modelDifferenctToolIcon");
//       this._group.addControl(this._button);
//     }
//   }
//   Autodesk.Viewing.theExtensionManager.registerExtension(
//     "ModelDiff",
//     ModelDiff,
//   );
//   return { id: "ModelDiff", options: {} };
// };

export const Deff = (Autodesk) => {
  class ModelDiff extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
      super(viewer, options);
      this._group = null;
      this._button = null;
    }

    load() {
      console.log("Model Difference has been loaded");
      return true;
    }

    unload() {
      console.log("Model Difference has been unloaded");
      return true;
    }

    modelDiff() {
      const models = this.viewer.impl.get3DModels();

      if (!models || models.length < 2) {
        console.warn("ModelDiff: need 2 loaded models, got", models?.length);
        return;
      }

      const extensionConfig = {
        mimeType: "application/vnd.autodesk.revit",
        primaryModels: [models[0]],
        diffModels: [models[1]],
        diffMode: "overlay",
        versionA: "1",
        versionB: "2",
      };

      this.viewer
        .loadExtension("Autodesk.DiffTool", extensionConfig)
        .catch((err) => console.log(err));
    }

    onToolbarCreated() {
      this._group = this.viewer.toolbar.getControl("modelDifferenctTool");

      if (!this._group) {
        this._group = new Autodesk.Viewing.UI.ControlGroup(
          "modelDifferenctTool",
        );
        this.viewer.toolbar.addControl(this._group);
      }

      this._button = new Autodesk.Viewing.UI.Button("diffToolButtonCombo");
      this._button.onClick = () => this.modelDiff();
      this._button.setToolTip("Compare Models");
      this._button.addClass("modelDifferenctToolIcon");
      this._group.addControl(this._button);
    }
  }

  Autodesk.Viewing.theExtensionManager.registerExtension(
    "ModelDiff",
    ModelDiff,
  );
  return { id: "ModelDiff", options: {} };
};
